const DATA_IMAGE_PREFIX_REGEX = /^data:image\//i;
const WEB_IMAGE_URL_PREFIX_REGEX = /^(https?:\/\/|blob:|\/\/)/i;
const BASE64_IMAGE_CONTENT_REGEX = /^[A-Za-z0-9+/]+={0,2}$/;
const MIN_BASE64_IMAGE_LENGTH = 64;

export const normalizeImageSource = (value?: string | null) => {
  if (value === null || value === undefined) {
    return value;
  }

  const trimmedValue = value.trim();
  if (trimmedValue === '') {
    return trimmedValue;
  }

  if (
    DATA_IMAGE_PREFIX_REGEX.test(trimmedValue) ||
    WEB_IMAGE_URL_PREFIX_REGEX.test(trimmedValue)
  ) {
    return trimmedValue;
  }

  const compactValue = trimmedValue.replace(/\s+/g, '');
  if (
    compactValue.length >= MIN_BASE64_IMAGE_LENGTH &&
    BASE64_IMAGE_CONTENT_REGEX.test(compactValue)
  ) {
    return `data:image/jpeg;base64,${compactValue}`;
  }

  return trimmedValue;
};
